import React from 'react'
import ErrorOutlineOutlinedIcon from '@material-ui/icons/ErrorOutlineOutlined';
import CheckCircleOutlinedIcon from '@material-ui/icons/CheckCircleOutlined'
import CloseOutlinedIcon from '@material-ui/icons/CloseOutlined'

export function getStartIcon(severity){
    if(severity === 'error'){
        return <ErrorOutlineOutlinedIcon />
    }
    else {
        return <CheckCircleOutlinedIcon />
    }
}

export function getEndIcon() { 
    return <CloseOutlinedIcon />
}